import AttachFileIcon from '@mui/icons-material/AttachFile';
import { BaseTextFieldProps, IconButton, InputAdornment, styled, TextField } from '@mui/material';
import { ChangeEvent, EventHandler, FC, useState } from 'react';
import { take } from 'rxjs';
import { IUploadFileCommon, uploadFilesToS3, useFileSizeGuard } from '../fileUpload.component';

export const UploadField: FC<IField> = ({
  accept = '*',
  multiple = false,
  place,
  maxFileSize,
  fileName = '',
  value: _value,
  onLoading,
  onUploaded,
  ...rest
}) => {
  const [inputKey, setInputKey] = useState<number>(0);
  const isSizeAllowed = useFileSizeGuard(maxFileSize);
  const handleFileUpload: EventHandler<ChangeEvent<HTMLInputElement>> = (evt) => {
    evt.stopPropagation();

    const files = evt.currentTarget.files;
    if (!isSizeAllowed(files)) {
      // Remount input so the user can pick again, including the same file after shrinking it
      setInputKey((prev) => prev + 1);
      return;
    }
    if (typeof onLoading === 'function' && files?.length !== 0) {
      onLoading();
    }
    uploadFilesToS3({ files, place })
      .pipe(take(1))
      .subscribe((result) => {
        if (typeof onUploaded === 'function') {
          onUploaded(result);
        }
      });
    // Remount input to clear selected files and allow uploading the same file again
    setInputKey((prev) => prev + 1);
  };

  return (
    <SLabel htmlFor='file-upload'>
      <TextField
        title={fileName}
        size='small'
        {...rest}
        value={fileName}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton component='span'>
                  <AttachFileIcon />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <input
        key={inputKey}
        id='file-upload'
        type='file'
        hidden
        accept={accept}
        multiple={multiple}
        onChange={handleFileUpload}
      />
      <div title={fileName} style={{ position: 'absolute', width: '100%', height: '100%' }} />
    </SLabel>
  );
};
interface IField extends IUploadFileCommon, BaseTextFieldProps {
  fileName?: string;
}
const SLabel = styled('label')({
  position: 'relative',
  display: 'inline-flex',
});
